import { createFileRoute } from '@tanstack/react-router';
import { GlobalChat } from '@/components/chat/GlobalChat.tsx';

export const Route = createFileRoute('/$spaceSlug/chat')({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: 'Findya | Chat',
      },
    ],
  }),
});

function RouteComponent() {
  return (
    <div className="flex grow overflow-hidden">
      <GlobalChat />
    </div>
  );
}
